"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Separator = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
require("./Separator.pc.css");
const Separator = ({ light, vertical }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_e8b4a98b', '_e8b39903', '_pub-e8b39903', '_pub-3c25d522', {
            '_e8b39903_light _pub-e8b39903_light _pub-3c25d522_light light': light,
            '_e8b39903_vertical _pub-e8b39903_vertical _pub-3c25d522_vertical vertical': vertical,
        }) }));
};
exports.Separator = Separator;
//# sourceMappingURL=Separator.js.map